<template>
  <div data-sidebar="footer" class="flex flex-col overflow-visible">
    <slot />
  </div>
</template>
